const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function parseDate(value) {
  if (!value) return null;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

export function fmtDate(value) {
  const d = parseDate(value);
  if (!d) return "—";
  const yy = String(d.getFullYear()).slice(-2);
  return `${String(d.getDate()).padStart(2, "0")}-${MONTHS[d.getMonth()]}-${yy}`;
}

export function toInputDate(value) {
  const d = parseDate(value);
  if (!d) return "";
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function today() {
  return toInputDate(new Date());
}

export function fmtMoney(value) {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  if (isNaN(n)) return String(value);
  return `₹${n.toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
}

export function fmtNumber(value) {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  if (isNaN(n)) return String(value);
  return n.toLocaleString("en-IN");
}

export const LD_CLASSES = {
  red: "bg-red-50 text-red-700 border-red-200 dark:bg-red-950/40 dark:text-red-300 dark:border-red-800",
  amber: "bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800",
  green: "bg-emerald-50 text-emerald-800 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800",
  grey: "bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-900 dark:text-slate-400 dark:border-slate-800",
};

export const PRIORITY_CLASSES = {
  escalated: LD_CLASSES.red,
  overdue: LD_CLASSES.red,
  "due today": LD_CLASSES.amber,
  upcoming: LD_CLASSES.grey,
};

export const STAGES = [
  { value: 2, label: "Site readiness update" },
  { value: 6, label: "Dispatch update" },
  { value: 7, label: "Transit update" },
  { value: 8, label: "Installation update" },
  { value: 10, label: "Billing update" },
  { value: 11, label: "Payment update" },
  { value: 13, label: "Closed" },
];

export const SITE_STATUS = ["Ready", "Not ready", "On hold"];
export const YES_NO_NA = ["Yes", "No", "NA"];
export const PAYMENT_STATUS = ["Pending", "Part received", "Received", "On hold"];
export const DELAY_REASONS = [
  "None",
  "Site not ready",
  "Panel oversize or approval",
  "Portal rejection",
  "Delay at our end",
  "Transport",
  "Other",
];
